import { qs } from "../utils/dom.js"
export function initFormHelpers() {
  const postalCodeField = qs("#id_postal_code")
  if (postalCodeField)
    postalCodeField.addEventListener("change", async (e) => {
      const r = await fetch(`/plz/${e.target.value}/`)
      if (r.ok) {
        const rec = await r.json()

        let el
        if ((el = qs("#id_city"))) el.value = rec.city
        if ((el = qs("#id_canton"))) el.value = rec.canton
      }
    })
}
